import React from 'react'
import Header from '../../components/Header/Header'
import Footer from '../../components/Footer/Footer'
const thescience = () => {
    return (
        <div>
            <Header />
            <section className="banner">
                <div className="banner-blk ">

                    <div className="container">
                        <div className="row align-items-center">

                            <div className="col-md-6">
                                <div className="content-blk ">

                                    <div className="hero-eyebrow">
                                        <span claclassNamess="hero-dot"></span>
                                        <span className="overline">The Science · 25-Question Compatibility Session · Apple Watch + Video</span>
                                    </div>
                                    <h1 className="disp-xl">
                                        One hour.<br />25 questions.
                                        <em className="coral">A lifetime of clarity.</em>
                                    </h1>
                                    <p className="body-lg">
                                        Our live compatibility session pairs your spoken answers with real-time physiological data from your Apple Watch — while video analysis reads what your face and voice reveal that words alone cannot. The result is the most complete picture of two-person compatibility ever measured.
                                    </p>
                                    <div className="hero-btns">
                                        <button className="btn btn-coral">See the Full Session <span className="arr">→</span></button>
                                        <button className="btn btn-outline">Add DNA Compatibility</button>
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-6">
                                <div class="hero-img-stack">
                                    <img alt="" src="/images/thescience.jpg"/>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >


            <div className="sec sec-white">
                <div className="sec-label">
                    <span className="overline text-coral">
                        Three simultaneous input streams
                    </span>
                </div>

                <h2 className="disp-md">
                    Your Apple Watch. Your camera.<br />
                    Your words. All at once.
                </h2>

                <p className="sec-sub">
                    While you answer 25 structured questions in conversation with your match,
                    three data streams run continuously — capturing signals that neither person
                    can consciously control or perform.
                </p>

                <div className="grid g3 mt-40 gap-20 inputstreams">

                    {/* Stream 1 */}
                    <div className="card">
                        <div className="card-header dark">
                            <div className="icon">⌚</div>
                            <div className="stream-label">Stream 1</div>
                            <div className="card-title">Apple Watch</div>
                            <div className="card-sub">Series 9+ · Ultra 2+ · Ultra 4</div>
                        </div>

                        <div className="card-body">
                            <div className="list">
                                <div className="list-item coral">
                                    <div className="pinkdot"></div>
                                    <div>
                                        <div className="title">Heart Rate Variability (HRV)</div>
                                        <div className="desc">SDNN & RMSSD · every question · both participants</div>
                                    </div>
                                </div>

                                <div className="list-item coral">
                                    <div className="pinkdot"></div>
                                    <div>
                                        <div className="title">BP Pattern Score</div>
                                        <div className="desc">0–100 normalised · PPG waveform analysis</div>
                                    </div>
                                </div>

                                <div className="list-item coral">
                                    <div className="pinkdot"></div>
                                    <div>
                                        <div className="title">Heart Rate</div>
                                        <div className="desc">Continuous BPM · spike detection per question</div>
                                    </div>
                                </div>

                                <div className="list-item sage">
                                    <div className="pinkdot"></div>
                                    <div>
                                        <div className="title">Skin Temperature</div>
                                        <div className="desc">Thermal arousal signal · Ultra 4+ adds direct mmHg</div>
                                    </div>
                                </div>

                                <div className="list-item sage">
                                    <div className="pinkdot"></div>
                                    <div>
                                        <div className="title">Respiration Rate</div>
                                        <div className="desc">Breath synchrony between both participants</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Stream 2 */}
                    <div className="card">
                        <div className="card-header indigo">
                            <div className="icon">📹</div>
                            <div className="stream-label">Stream 2</div>
                            <div className="card-title">Video + Audio AI</div>
                            <div className="card-sub">iPhone / MacBook camera · real-time</div>
                        </div>

                        <div className="card-body">
                            <div className="list">
                                <div className="list-item indigo">
                                    <div className="bluedot"></div>
                                    <div>
                                        <div className="title">Facial Expression Analysis</div>
                                        <div className="desc">68 facial landmark points · micro-expression detection</div>
                                    </div>
                                </div>

                                <div className="list-item indigo">
                                    <div className="bluedot"></div>
                                    <div>
                                        <div className="title">Voice Prosody</div>
                                        <div className="desc">Pitch, pace, warmth, hesitation, laughter</div>
                                    </div>
                                </div>

                                <div className="list-item indigo">
                                    <div className="bluedot"></div>
                                    <div>
                                        <div className="title">rPPG Pulse Detection</div>
                                        <div className="desc">Remote PPG from facial colour changes</div>
                                    </div>
                                </div>

                                <div className="list-item lavender">
                                    <div className="bluedot"></div>
                                    <div>
                                        <div className="title">Gaze & Attention</div>
                                        <div className="desc">Eye contact, look-away frequency, pupil estimate</div>
                                    </div>
                                </div>

                                <div className="list-item lavender">
                                    <div className="bluedot"></div>
                                    <div>
                                        <div className="title">Speech Transcription</div>
                                        <div className="desc">Semantic sentiment scored per answer</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Stream 3 */}
                    <div className="card">
                        <div className="card-header gold">
                            <div className="icon">💬</div>
                            <div className="stream-label">Stream 3</div>
                            <div className="card-title">Verbal Answers</div>
                            <div className="card-sub">25 structured questions · scored & matched</div>
                        </div>

                        <div className="card-body">
                            <div className="list">
                                <div className="list-item gold">
                                    <div className="browndot"></div>
                                    <div>
                                        <div className="title">Values Alignment</div>
                                        <div className="desc">Family, ambition, lifestyle, conflict, finances</div>
                                    </div>
                                </div>

                                <div className="list-item gold">
                                    <div className="browndot"></div>
                                    <div>
                                        <div className="title">Attachment Style</div>
                                        <div className="desc">Secure, anxious, avoidant, disorganised</div>
                                    </div>
                                </div>

                                <div className="list-item gold">
                                    <div className="browndot"></div>
                                    <div>
                                        <div className="title">Semantic Similarity</div>
                                        <div className="desc">0–100 vector similarity scale</div>
                                    </div>
                                </div>

                                <div className="list-item gold">
                                    <div className="browndot"></div>
                                    <div>
                                        <div className="title">Emotional Resonance</div>
                                        <div className="desc">HRV change per answer detected</div>
                                    </div>
                                </div>

                                <div className="list-item sage">
                                    <div className="browndot"></div>
                                    <div>
                                        <div className="title">Consistency Score</div>
                                        <div className="desc">Alignment or divergence flagged</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>


            <div class="sec sec-blush">

                <div class="sec-label">
                    <span class="overline text-coral">Session architecture</span>
                </div>

                <h2 class="disp-md">
                    25 questions. 5 domains.<br />
                    ~60 minutes. Every signal captured.
                </h2>

                <p class="sec-sub">
                    The session is structured — not scripted. Questions are open-ended and ordered to create natural escalating intimacy, mirroring the way real relationships deepen. Your physiological response to each domain is what the system is really measuring.
                </p>

                <div id="qdomains" class="qdomains">

                    <div class="container py-5">

                        <div class="accordion custom-accordion" id="accordionExample">


                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingOne">
                                    <button class="accordion-button custom-header" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne">

                                        <div class="d-flex justify-content-between w-100 align-items-center">

                                            <div class="d-flex align-items-center gap-3">
                                                <div class="circle coral">1–5</div>

                                                <div>
                                                    <div class="meta coral">DOMAIN 1 · MINUTES 0–12</div>
                                                    <div class="title">Life Vision & Values</div>
                                                </div>
                                            </div>

                                            <div class="time">~2.5 min each</div>
                                        </div>

                                    </button>
                                </h2>

                                <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                    <div class="accordion-body">

                                        <div class="row g-3">

                                            <div class="col-md-6">
                                                <div class="questionsbox">
                                                    <h6>Sample Questions</h6>
                                                    <ul>
                                                        <li>Q1: "Describe your ideal life in ten years — not career, just life."</li>
                                                        <li>Q2: "What does family mean to you, and what role does it play in your decisions?"</li>
                                                        <li>Q3: "How do you decide what's worth sacrificing for, and what isn't?"</li>
                                                        <li>Q4: "What's your relationship with money — security tool or freedom tool?"</li>
                                                        <li>Q5: "Where do you want to live, and why does that feel right to you?"</li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="questionsbox">
                                                    <h6 class="coral">What We Measure</h6>
                                                    <ul>
                                                        <li>Baseline HRV established — personal session normal set in first 3 minutes </li>
                                                        <li>Values alignment score: semantic similarity of life-vision answers (0–100 scale)</li>
                                                        <li>HR spike detection: does your heart rate rise when they describe their ideal life?</li>
                                                        <li>Facial warmth score: genuine smile Duchenne marker frequency</li>
                                                    </ul>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>


                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed custom-header" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo">

                                        <div class="d-flex justify-content-between w-100 align-items-center">
                                            <div class="d-flex align-items-center gap-3">
                                                <div class="circle indigo">6–10</div>

                                                <div>
                                                    <div class="meta indigo">DOMAIN 2 · MINUTES 12–24</div>
                                                    <div class="title">Emotional World & Attachment</div>
                                                </div>
                                            </div>

                                            <div class="time">~2.5 min each</div>
                                        </div>

                                    </button>
                                </h2>

                                <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                    <div class="accordion-body">

                                        <div class="row g-3">

                                            <div class="col-md-6">
                                                <div class="questionsbox">
                                                    <h6>Sample Questions</h6>
                                                    <ul>
                                                        <li>Q6: "How do you behave when you feel emotionally overwhelmed?"</li>
                                                        <li>Q7: "What does feeling truly loved look and feel like for you?"</li>
                                                        <li>Q8: "How do you typically respond when someone close to you is in pain?"</li>
                                                        <li>Q9: "Describe a moment when you felt completely understood."</li>
                                                        <li>Q10: "What's your default reaction when someone disappoints you?"</li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="questionsbox">
                                                    <h6 class="coral">What We Measure</h6>
                                                    <ul>
                                                        <li>Attachment style classification: secure, anxious, avoidant signals in natural language</li>
                                                        <li>HRV suppression when discussing vulnerability — empathy signal or threat response</li>
                                                        <li>Voice warmth score: does your tone shift toward openness when asked about love?</li>
                                                        <li>Emotional resonance: bp_pattern_score response to their vulnerability answers</li>
                                                    </ul>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>


                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed custom-header" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree">

                                        <div class="d-flex justify-content-between w-100 align-items-center">
                                            <div class="d-flex align-items-center gap-3">
                                                <div class="circle gold">11–15</div>

                                                <div>
                                                    <div class="meta gold">DOMAIN 3 · MINUTES 24–37</div>
                                                    <div class="title">Conflict & Resilience</div>
                                                </div>
                                            </div>

                                            <div class="time">~2.5 min each</div>
                                        </div>

                                    </button>
                                </h2>

                                <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                    <div class="accordion-body">

                                        <div class="row g-3">

                                            <div class="col-md-6">
                                                <div class="questionsbox">
                                                    <h6>Sample Questions</h6>
                                                    <ul>
                                                        <li>Q11: "Walk me through the last real argument you had — how did it start and end?"</li>
                                                        <li>Q12: "What does fair fighting look like to you in a relationship?"</li>
                                                        <li>Q13: "How do you handle being wrong in a disagreement?"</li>
                                                        <li>Q14: "Describe a time you stayed in a relationship past the point you should have."</li>
                                                        <li>Q15: "What's the thing that, in a relationship, you find hardest to forgive?"</li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="questionsbox">
                                                    <h6 class="coral">What We Measure</h6>
                                                    <ul>
                                                        <li>Stress-response spike: does discussing conflict elevate bp_pattern_score? Severity and recovery speed</li>
                                                        <li>Conflict style compatibility: do your regulation patterns align or clash?</li>
                                                        <li>Voice hesitation: pauses, pitch drops, micro-tremors when recounting conflict moments</li>
                                                        <li>Stabilisation interval HRV: recovery rate after conflict questions — physiological resilience index</li>
                                                    </ul>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed custom-header" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour">

                                        <div class="d-flex justify-content-between w-100 align-items-center">
                                            <div class="d-flex align-items-center gap-3">
                                                <div class="circle sage">11–15</div>

                                                <div>
                                                    <div class="meta gold">Domain 4 · Minutes 37–50</div>
                                                    <div class="title">Intimacy & Partnership</div>
                                                </div>
                                            </div>

                                            <div class="time">~2.5 min each</div>
                                        </div>

                                    </button>
                                </h2>

                                <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                    <div class="accordion-body">

                                        <div class="row g-3">

                                            <div class="col-md-6">
                                                <div class="questionsbox">
                                                    <h6>Sample Questions</h6>
                                                    <ul>
                                                        <li>Q16: "What does real partnership in a relationship feel like versus what you've experienced?"</li>
                                                        <li>Q17: "How does physical closeness connect to your emotional state?"</li>
                                                        <li>Q18: "What do you need from a partner in your lowest moments?"</li>
                                                        <li>Q19: "Describe the best relationship you've witnessed — real or fictional."</li>
                                                        <li>Q20: "What do you offer a partner that most people don't?"</li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="questionsbox">
                                                    <h6 class="coral">What We Measure</h6>
                                                    <ul>
                                                        <li>Peak HRV synchrony — this domain produces the strongest physiological alignment signal</li>
                                                        <li>bp_synchrony_score peaks here: both systems aroused by intimacy language together</li>
                                                        <li>Gaze duration longest in this domain — eye contact as intimacy signal captured</li>
                                                        <li>Oxytocin-linked OXTR gene variant modulates expected response — DNA layer active</li>
                                                    </ul>
                                                </div>
                                            </div>

                                        </div>

                                    </div>

                                </div>
                            </div>


                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed custom-header" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive">

                                        <div class="d-flex justify-content-between w-100 align-items-center">
                                            <div class="d-flex align-items-center gap-3">
                                                <div class="circle lavender">11–15</div>

                                                <div>
                                                    <div class="meta gold">Domain 5 · Minutes 50–63</div>
                                                    <div class="title">Future & Growth</div>
                                                </div>
                                            </div>

                                            <div class="time">~2.5 min each</div>
                                        </div>

                                    </button>
                                </h2>

                                <div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                    <div class="accordion-body">

                                        <div class="row g-3">

                                            <div class="col-md-6">
                                                <div class="questionsbox">
                                                    <h6>Sample Questions</h6>
                                                    <ul>
                                                        <li>Q21: "How do you feel about children — wanting them, timing, how many?"</li>
                                                        <li>Q22: "What kind of growth do you expect a partner to support in you?"</li>
                                                        <li>Q23: "Describe a future version of yourself you're genuinely excited about."</li>
                                                        <li>Q24: "What makes you stay in things — relationships, jobs, places — when they get hard?"</li>
                                                        <li>Q25: "What would a great life together look like — and what would you need to build it?"</li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="questionsbox">
                                                    <h6 class="coral">What We Measure</h6>
                                                    <ul>
                                                        <li>Post-session stabilisation: does HRV return to within-session baseline within 10 minutes? Recovery speed = positive signal</li>
                                                        <li>Family-planning alignment: Q21 answer matched against reproductive compatibility stage (DNA layer)</li>
                                                        <li>Final bp_synchrony_score: cross-correlation across entire 63-minute session window</li>
                                                        <li>Excitement signal on Q25: does imagining a future together produce a physiological arousal spike for both?</li>
                                                    </ul>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>


                </div>
            </div>


            <div class="sec sec-white">
                <div class="sec-label">
                    <span class="overline text-coral">How answers become a score</span>
                </div>

                <h2 class="disp-md">
                    Every answer scored<br />on five dimensions — simultaneously.
                </h2>

                <p class="sec-sub">
                    Your verbal answer, your body's physiological response to giving it, and your body's response to
                    <em>hearing theirs</em> — all three are scored independently and then fused. No single dimension decides the outcome.
                </p>

                <div class="grid-two mt-40">

                    <div class="fivedimensions">

                        <div class="card card-cream mb-16">
                            <div class="card-title text-coral">
                                PER-QUESTION SCORING DIMENSIONS
                            </div>

                            <div class="score-list">

                                <div class="score-item">
                                    <div class="score-header">
                                        <span>Semantic alignment</span>
                                        <span class="score-range coral">0 – 100</span>
                                    </div>
                                    <div class="progress">
                                        <div class="progress-bar coral w-72"></div>
                                    </div>
                                    <div class="score-desc">
                                        How similar are your answers in meaning, not just words
                                    </div>
                                </div>

                                <div class="score-item">
                                    <div class="score-header">
                                        <span>Physiological response to their answer</span>
                                        <span class="score-range indigo">0 – 100</span>
                                    </div>
                                    <div class="progress">
                                        <div class="progress-bar indigo w-85"></div>
                                    </div>
                                    <div class="score-desc">
                                        HRV + bp_pattern_score while listening
                                    </div>
                                </div>

                                <div class="score-item">
                                    <div class="score-header">
                                        <span>Vocal emotional resonance</span>
                                        <span class="score-range gold">0 – 100</span>
                                    </div>
                                    <div class="progress">
                                        <div class="progress-bar gold w-64"></div>
                                    </div>
                                    <div class="score-desc">
                                        Warmth, openness, energy
                                    </div>
                                </div>

                                <div class="score-item">
                                    <div class="score-header">
                                        <span>Facial microexpression match</span>
                                        <span class="score-range sage">0 – 100</span>
                                    </div>
                                    <div class="progress">
                                        <div class="progress-bar sage w-58"></div>
                                    </div>
                                    <div class="score-desc">
                                        Genuine smile, curiosity, interest
                                    </div>
                                </div>

                                <div class="score-item">
                                    <div class="score-header">
                                        <span>Self/body consistency</span>
                                        <span class="score-range lavender">0 – 100</span>
                                    </div>
                                    <div class="progress">
                                        <div class="progress-bar lavender w-90"></div>
                                    </div>
                                    <div class="score-desc">
                                        Alignment between words & body
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="card card-info">
                            <div class="card-title text-indigo">
                                PRIVACY — YOUR ANSWERS ARE YOURS
                            </div>
                            <p class="card-text">
                                Your partner never sees your per-question scores, raw physiological readings, or verbal transcripts. They receive the same composite Total Compatibility Score you do. Dual-party revocable consent token required before any session comparison proceeds (DNA CIP Claim 3, Patent FIG. 16).
                            </p>
                        </div>

                    </div>

                    <div>

                        <div class="card card-cream">

                            <div class="card-title text-coral">
                                LIVE SESSION DATA — WHAT THE SYSTEM SEES
                            </div>


                            <div class="wave-box">
                                <div class="wave-label">
                                    bp_synchrony_score · Real-time · Both participants
                                </div>

                                <canvas id="session-wave" class="wave-canvas"></canvas>

                                <div class="wave-legend">
                                    <div class="legend-item">
                                        <span class="line coral"></span> Person A
                                    </div>
                                    <div class="legend-item">
                                        <span class="line indigo"></span> Person B
                                    </div>
                                    <div class="legend-item">
                                        <span class="line dashed"></span> Baseline
                                    </div>
                                </div>
                            </div>


                            <div class="tracker-title">
                                PER-QUESTION COMPATIBILITY SIGNAL
                            </div>

                            <div class="q-tracker" id="q-tracker">

                                <div class="qb qb-coral">1</div>
                                <div class="qb qb-coral">2</div>
                                <div class="qb qb-indigo">6</div>

                            </div>


                            <div class="score-box">
                                <div class="score-value" id="live-score">80</div>
                                <div class="score-meta">
                                    <div class="score-title">Total Compatibility Score</div>
                                    <div class="score-desc">
                                        Computed continuously · finalised at session end
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>
            </div>



            <div class="sec sec-blush">
                <div class="sec-label">
                    <span class="overline coral-text">After the session</span>
                </div>

                <h2 class="disp-md">
                    Your score. Your insights.<br />
                    Your next step.
                </h2>

                <div class="grid g3 mt-36 gap-20">

                    <div class="card">
                        <div class="icon-circle coral">
                            📊
                        </div>
                        <h3>Full compatibility report</h3>
                        <p>
                            Domain-by-domain breakdown: which of the 5 areas you're strongest on,
                            where you differ, and what that means in practice. Framed in language you can actually use.
                        </p>
                    </div>

                    <div class="card">
                        <div class="icon-circle indigo">
                            🔁
                        </div>
                        <h3>6-month check-in sessions</h3>
                        <p>
                            If you become a couple, FutureSoulmates tracks your bp_synchrony_score
                            across recurring sessions every 6 months. A declining trend triggers a
                            relationship health advisory — before either of you feels the distance.
                        </p>
                    </div>

                    <div class="card">
                        <div class="icon-circle sage">
                            🧬
                        </div>
                        <h3>DNA layer (optional upgrade)</h3>
                        <p>
                            Add your 1,520-gene DNA panel to the session score and unlock genetic
                            compatibility, HLA immune matching, reproductive carrier risk, and the
                            full TotalCompatibilityScore formula.
                        </p>
                    </div>

                </div>

                <div class="pat mt-28">
                    <div class="pat-icon">⚖️</div>
                    <div class="pat-txt">
                        <strong>Everything in the session is patent-protected.</strong>
                        DNA CIP (priority Provisional 63/734,157): Claim 1 covers bp_synchrony_score
                        as a compatibility signal; Claim 2 covers longitudinal relationship health
                        monitoring across recurring sessions; Claim 3 covers the dual-party revocable
                        consent token architecture — neither partner's raw data is ever accessible to
                        the other. U.S. Application 19/407,993 and CIP cover the multimodal AI fusion
                        of biometric, video, psychometric, and genomic signals into a single
                        compatibility embedding. No prior art identified in any of these claim spaces.
                    </div>
                </div>
            </div>

            <div>
                <section class="trusted-story">
                    <div class="container p-0">
                        <div class="cta-sec cta-coral">
                            <h2 class="disp-md">Ready to have the most revealing conversation of your dating life?</h2>
                            <p>Sessions begin Q1 2027. Join the waitlist — DNA kit ships Q3 2026.</p>
                            <div class="cta-btns">
                                <button class="btn btn-white">Add DNA Compatibility <span class="arr">→</span></button>
                                <button class="btn investerbtn">Family Planning</button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>


            <Footer />
        </div>
    )
}

export default thescience
